module.exports = __webpack_public_path__ + "img/feature-4.644131a6.png";